













































/* tslint:disable:max-line-length */

import { DailyPivotDistributionDistGroup } from '@empathybroker/tsclient-stats/dist/models/distributionreport/dailypivot/data/dailypivotdistribution-distgroup';
import { DailyPivotDistributionDistItem } from '@empathybroker/tsclient-stats/dist/models/distributionreport/dailypivot/data/dailypivotdistribution-distitem';
import { PivotedQueriesDataItem } from '@empathybroker/tsclient-stats/dist/models/pivoted-queries/pivoted-queries-data-item';
import { mapActions, mapGetters } from 'vuex';

import { ApiEnum, DeviceEnum, FilterIdEnum, FilterTypeEnum, KpiEnum } from '../../../enums';

import { capitalizeSentence } from '../../../filters';

import { Filter, RegularFilter } from '../../../models';

import { ANALYTICS_CONSTS } from '../../../store/analytics/analytics.consts';
import { CONFIG_CONSTS } from '../../../store/config/config.consts';
import { CONTEXT_CONSTS } from '../../../store/context/context.consts';

import { UiSwitch } from '../../keen-ui';
import Tabs from '../../tabs.component.vue';
import KpisLegend from '../kpis-legend.component.vue';
import PivotsChart from './pivots-chart.component.vue';
import PivotsTable from './pivots-table.component.vue';

/* tslint:enable:max-line-length */

export default {
  name: 'pivots',
  components: {
    KpisLegend,
    PivotsChart,
    PivotsTable,
    Tabs,
    UiSwitch
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context
    }),
    ...mapGetters(ANALYTICS_CONSTS.moduleName, {
      data: ANALYTICS_CONSTS.getters.data,
      selectedId: ANALYTICS_CONSTS.getters.selectedId
    }),
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      kpis: CONFIG_CONSTS.getters.kpis
    }),
    supportedKpis: function (): KpiEnum[] {
      const supportedKpis = [
        KpiEnum.QUERIES,
        KpiEnum.CLICKS,
        KpiEnum.FINDABILITY,
        KpiEnum.ADD2CART,
        KpiEnum.CHECKOUT,
        KpiEnum.NO_RESULTS
      ];
      return this.kpis.filter((kpi: KpiEnum) => supportedKpis.includes(kpi));
    },
    pivotData: function (): any[] {
      let statePivotData;
      if (!this.selectedId) {
        statePivotData = this.data.overall.pivots[this.pivotId];
      } else if (this.data.ids[this.selectedId]) {
        statePivotData = this.data.ids[this.selectedId].pivots[this.pivotId];
      }
      if (!statePivotData) {
        return [];
      }
      let pivotData;
      if (!this.selectedId) {
        pivotData = statePivotData.currentPeriod.data.distributionData.map((pivotDataItem: DailyPivotDistributionDistGroup) => ({
          id: pivotDataItem.pivots[0].value
        }));
      } else {
        pivotData = statePivotData.currentPeriod.data.items.map((pivotDataItem: PivotedQueriesDataItem) => ({
          id: Object.values(pivotDataItem.pivots)[0]
        }));
      }
      Object.keys(statePivotData).forEach((periodId: string) => {
        const periodData = statePivotData[periodId].data;
        if (!this.selectedId) {
          periodData.distributionData.forEach((pivotDataItem: DailyPivotDistributionDistGroup) => {
            const pivotValueData = pivotData.find((valueData) => valueData.id === pivotDataItem.pivots[0].value);
            if (!!pivotValueData) {
              pivotValueData[periodId] = this.getPeriodData(pivotDataItem);
            }
          });
        } else {
          periodData.items.forEach((pivotDataItem: PivotedQueriesDataItem) => {
            const pivotValueData = pivotData.find((valueData) => valueData.id === Object.values(pivotDataItem.pivots)[0]);
            if (!!pivotValueData) {
              pivotValueData[periodId] = {
                queryCount: pivotDataItem.queryCount,
                clickCount: pivotDataItem.clickCount,
                findabilityCount: pivotDataItem.successCount,
                wishlistCount: pivotDataItem.wishlistCount,
                add2cartCount: pivotDataItem.add2cartCount,
                checkoutCount: pivotDataItem.checkoutCount,
                noResultsCount: pivotDataItem.queryNoResultsCount
              };
            }
          });
        }
      });
      pivotData = this.getPivotVolumes(pivotData);
      pivotData.sort(
        (pivotDataItem1: any, pivotDataItem2: any) => (pivotDataItem2.currentPeriod.queryCount -
          pivotDataItem1.currentPeriod.queryCount));
      return pivotData;
    },
    kpisOptions: function (): any[] {
      const kpisMessages = this.messages.kpis;
      return this.supportedKpis.map((kpi: KpiEnum) => {
        const kpiMessage = {
          [KpiEnum.QUERIES]: () => kpisMessages[KpiEnum.QUERIES],
          [KpiEnum.NO_RESULTS]: () => kpisMessages['noResults'],
          [KpiEnum.ADD2CART]: () => kpisMessages[KpiEnum.ADD2CART],
          [KpiEnum.FINDABILITY]: () => kpisMessages[KpiEnum.FINDABILITY],
          [KpiEnum.CLICKS]: () => kpisMessages[KpiEnum.CLICKS],
          [KpiEnum.CHECKOUT]: () => kpisMessages[KpiEnum.CHECKOUT]
        }[kpi]();
        return {
          id: kpi,
          text: kpiMessage.valueLabel.toUpperCase(),
          color: kpi
        };
      });
    },
    tabsOptions: function () {
      return Object.values(this.context.filters).reduce((tabsOptions: any[], filter: RegularFilter) => {
        if ((filter.config.type === FilterTypeEnum.REGULAR) && (filter.config.id !== FilterIdEnum.COMPARE)) {
          tabsOptions.push({
            id: (filter.config.taggingId || filter.config.id),
            text: (filter.config.prettyName || this.$epb.messages.filters.names[filter.config.id] || filter.config.id)
          });
        }
        return tabsOptions;
      }, []);
    },
    compareFilterValue: function (): string {
      const compareFilter = (Object.values(this.context.filters)
        .find((filter: Filter) => (filter.config.id === FilterIdEnum.COMPARE)) as RegularFilter);
      if (!!compareFilter) {
        return compareFilter.selectedValues[0];
      }
    },
    selectedKpiText: function (): string {
      const selectedKpiOptionText = this.kpisOptions.find(option => option.id === this.selectedKpi).text;
      return capitalizeSentence(selectedKpiOptionText.toLowerCase());
    },
    selectedTab: function (): RegularFilter {
      return this.tabsOptions.find((regularFilter) => regularFilter.id === this.pivotId);
    },
    selectedPivotKpiKey: function (): string {
      return {
        [KpiEnum.QUERIES]: () => 'queryCount',
        [KpiEnum.NO_RESULTS]: () => 'noResultsCount',
        [KpiEnum.CLICKS]: () => 'clickCount',
        [KpiEnum.FINDABILITY]: () => 'findabilityCount',
        [KpiEnum.ADD2CART]: () => 'add2cartCount',
        [KpiEnum.CHECKOUT]: () => 'checkoutCount'
      }[this.selectedKpi]();
    },
    pivotsComponentProps: function () {
      return {
        kpi: this.selectedKpi,
        compareFilterValue: this.compareFilterValue,
        pivot: this.selectedTab
      };
    },
    isMobileDevice: function (): boolean {
      return (this.$epb.device === DeviceEnum.MOBILE);
    }
  },
  data: function () {
    return {
      pivotId: undefined,
      pivotIdWatcher: undefined,
      selectedKpi: undefined,
      showRadarChart: false,
      messages: this.$epb.messages.analytics,
      loading: false
    };
  },
  methods: {
    ...mapActions(ANALYTICS_CONSTS.moduleName, {
      loadPivotData: ANALYTICS_CONSTS.actions.loadPivotData
    }),
    loadData: async function (): Promise<void> {
      this.loading = true;
      try {
        await this.loadPivotData({ pivotId: this.pivotId, selectedId: this.selectedId });
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.STATS));
      } finally {
        this.loading = false;
      }
    },
    getPeriodData: function (pivotDataItem: DailyPivotDistributionDistGroup) {
      const pivotDataItemValues = { ...pivotDataItem };
      return pivotDataItemValues.distributionDataPivots.reduce((accumulator, distItem: DailyPivotDistributionDistItem) => {
        return {
          queryCount: (accumulator.queryCount + distItem.queryCount),
          clickCount: (accumulator.clickCount + distItem.clickCount),
          findabilityCount: (accumulator.findabilityCount + distItem.findabilityCount),
          wishlistCount: (accumulator.wishlistCount + distItem.wishlistCount),
          add2cartCount: (accumulator.add2cartCount + distItem.add2cartCount),
          checkoutCount: (accumulator.checkoutCount + distItem.checkoutCount),
          noResultsCount: (accumulator.noResultsCount + distItem.noResultsCount)
        };
      }, {
        queryCount: 0,
        clickCount: 0,
        findabilityCount: 0,
        wishlistCount: 0,
        add2cartCount: 0,
        checkoutCount: 0,
        noResultsCount: 0
      });
    },
    getPivotVolumes: function (pivotData) {
      const pivotDataVolumes = [...pivotData];
      const totalCurrentCount = pivotDataVolumes.reduce((accum: number, pivot) => (accum + pivot.currentPeriod[this.selectedPivotKpiKey]),
        0);
      const totalPreviousCount = pivotDataVolumes.reduce((accum: number, pivot) => {
        const value = !!pivot[this.compareFilterValue] ? pivot[this.compareFilterValue][this.selectedPivotKpiKey] : 0;
        return accum + value;
      }, 0);
      pivotDataVolumes.forEach((pivotDataItem: any) => {
        pivotDataItem.currentVolume =
          (Math.round((pivotDataItem.currentPeriod[this.selectedPivotKpiKey] / totalCurrentCount) * 1000) / 10);
        if (!!pivotDataItem[this.compareFilterValue]) {
          pivotDataItem.previousVolume =
            (Math.round((pivotDataItem[this.compareFilterValue][this.selectedPivotKpiKey] / totalPreviousCount) * 1000) / 10);
        }
      });
      return pivotDataVolumes;
    },
    onKpiChange: function (selectedKpis: KpiEnum[]): void {
      this.selectedKpi = selectedKpis[0];
    }
  },
  created: function () {
    this.pivotId = this.tabsOptions[0].id;
    this.selectedKpi = this.kpisOptions[0].id;
    this.pivotIdWatcher = this.$watch('pivotId', this.loadData);
  },
  beforeDestroy: function (): void {
    this.pivotIdWatcher();
  }
};
